<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <brand-form />
      </div>
    </div>
  </section>
</template>

<script>
import brandForm from './Temp/BrandFormTemp.vue'

export default {
  name: 'Tables',
  components: {
    'brand-form': brandForm
  },
  methods: {
  },
  computed: {
    checkInput () {
      return this.$parent.checkInput
    },
    getDataH () {
      return this.$parent.getDataH
    }
  }
}
</script>



// WEBPACK FOOTER //
// CrBrand.vue?68cb3d08